import { SEND_FEEDBACK } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SEND_FEEDBACK.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEND_FEEDBACK.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SEND_FEEDBACK.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
